import { styled } from '@/stitches.config';

import { ReactComponent as ErrorIcon } from '@assets/icons/error.svg';
import { Box } from '@common/components';

export const StyledErrorIcon = styled(ErrorIcon, {
  height: '$12',
  width: '$12',
  color: '$error',
});

export const StyledContainer = styled(Box, {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
});

export const StyledActionsContainer = styled(Box, {
  width: '40%',
  margin: '$4 auto',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  textAlign: 'center',
});
